import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  trigger,
  transition,
  style,
  animate,
  ElementRef,
  ViewChild,
  AfterViewInit
} from '@angular/core';

@Component({
  selector: 'app-dialogmessenger',
  templateUrl: './dialogmessenger.component.html',
  styleUrls: ['./dialogmessenger.component.css'],
  animations: [
    trigger('dialog', [
      transition('void => *', [
        style({ transform: 'scale3d(.3, .3, .3)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'scale3d(.0, .0, .0)' }))
      ])
    ])
  ]
})
export class DialogmessengerComponent implements OnInit, AfterViewInit {
  @Input() showDialog: boolean = false;
  @Input() titleheader: string = '';
  @Input() title: string = '';
  @Input() titleBtn: string = 'OK';
  @Input() titleClose: string = '閉じる';
  @Input() showCloseBtn: boolean = false;
  @Input() modedialog: string;
  @Input() datafocus: string;
  @Output() oncloses: EventEmitter<any> = new EventEmitter();
  @Input() offheader: boolean = false;

  @Input() titleHtml: string = '';
  @ViewChild('confirmBtn') confirmBtn: ElementRef;

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {
    //console.log("dialogmessenger.ngAfterViewInit [START]");
    if (this.confirmBtn) {
      this.confirmBtn.nativeElement.focus();
    }
    //console.log("dialogmessenger.ngAfterViewInit [END]");
  }

  closeBtn(val) {
    this.oncloses.emit({
      clickdata: false,
      statusclick: val,
      mode: this.modedialog,
      focus: this.datafocus
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/dialogmessenger/dialogmessenger.component.ts